const eventReg = /^on(\w+)$/
export function formatOption(option = {}) {
  const renderOption = {
    on: {},
    // 在vue渲染中，会从attrs和props入参中获取所有 options.props 中申明的属性作为propsData处理，但不同的是 attrs取后会删除原对象的属性，而props不会
    props: {}
  }

  Object.entries(option).forEach(([key, val]) => {
    const type = typeof val
    if (type !== 'undefined' && val !== null) {
      const match = key.match(eventReg)
      // 作用域插槽的格式为
      // { name: props => VNode | Array<VNode> }
      // scopedSlots: {
      // default: props => createElement('span', props.text)
      // },
      if (key === 'scopedSlots') {
        renderOption.scopedSlots = val
      } else if (match && type === 'function') {
        const matchedKey = match[1]
        renderOption.on[`${matchedKey[0].toLowerCase()}${matchedKey.slice(1)}`] = val
      } else {
        renderOption.props[key] = val
      }
    }
  })
  return renderOption
}
